<template>
<div class="home-page-title-block">
    <div class="block-content">
        <div class="title-text">
            <div style="margin-right: 20px;font-weight: bold;">{{textList[listIndex].info}}</div>
            <div>{{textList[listIndex].english}}</div>
        </div>
        <div class="line-icon">
            <div></div>
            <img :src="titleIcon"></img>
            <div></div>
        </div>
    </div>
</div>
</template>

<script>
    import TitleIcon from '../../views/image/home_title_block_icon.png'
    export default {
        name: "home-page-title-block",
        props:{
          listIndex:String
        },
        data(){
            return{
                titleIcon:TitleIcon,
                textList:[
                    {info:'我们能做什么',english:'What can we do'},
                    {info:'用户场景',english:'User scenario'},
                    {info:'解决方案',english:'Solution'},
                    {info:'我们的优势',english:'Our advantage'},
                    {info:'公司简介',english:'Company Profile'},
                    {info:'公司荣誉',english:'Company Honor'},
                ]
            }
        }
    }
</script>

<style lang="scss" src="./home-page-title-block.scss" scoped>

</style>
